import { useEffect } from "react";
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { cqAPI, Auth } from "../../lib/Auth";
import { useToast } from "@chakra-ui/react";

const VerifyAccount = () => {
  const navigate = useNavigate()
  const toast = useToast();
  const { tokenId } = useParams();
  const [ searchParams ] = useSearchParams();

  const VerifyAndRedirect = ()=> {
    return cqAPI.post('/verify', {
      vtoken: tokenId,
      referrerHost: location.host
    }).then(response => {
      if (response.type === 'ok') {
        if (response.data.msg) {
          toast({
            title: 'Thank you',
            description: response.data.msg,
            status: 'success',
            isClosable: true,
          })
        }
        if (response.data.business) {
          localStorage.setItem('business', JSON.stringify(response.data.business))
        }
        Auth.storeUser(response.data.user);

        // if redir is non-empty, navigate to the url specified in redir or the home page
        const redir = searchParams.get("redir");
        navigate(redir || `/`);
      } else {
        toast({
          title: "Error",
          description: response.msg,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
        navigate('/');
      }
    }).catch((err) => {
      console.error('Verification failed:', err);
      toast({
        title: "Error",
        description: "Verification failed. Please try again.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      navigate('/');
    })
  }


  useEffect(()=>{
    if (Auth.user){
      Auth.signOut().then(() => {
        return VerifyAndRedirect()
      });
      return;
    }
    VerifyAndRedirect()
    },[])
}

export default VerifyAccount;